import script from "./photograph.vue?vue&type=script&setup=true&lang=ts"
export * from "./photograph.vue?vue&type=script&setup=true&lang=ts"

import "./photograph.vue?vue&type=style&index=0&id=60741b82&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60741b82"]])

export default __exports__